<template>
  <div>

    <h4>{{ $t('calendar.schema.data_for_calendar') }}</h4>
    <v-text-field v-model="eventName" :label="$t('calendar.schema.event_name_template')" class="schema-name-input"
                  @change="updateCalendar($event)"></v-text-field>
    <v-textarea v-model="eventDescription" :label="$t('calendar.schema.event_description_template')"
                class="schema-name-input"
                @change="updateCalendar($event)"></v-textarea>
    <v-text-field v-model="eventDate" :label="$t('calendar.schema.event_date_template')" class="schema-name-input"
                  @change="updateCalendar($event)"></v-text-field>
    <v-text-field v-model="eventTime" :label="$t('calendar.schema.event_hour_template')" class="schema-name-input"
                  @change="updateCalendar($event)"></v-text-field>

    <v-menu offset-y>
      <template v-slot:activator="{ on }">
        <div :style="getColorIconStyle(colorToHex())"></div>
        <v-text-field v-model="hexColor" class="schema-name-input" label="Kolor" @change="updateCalendar($event)"
                      v-on="on"></v-text-field>
      </template>

      <v-container style="background-color: #ffffff">
        <color-picker v-bind="color" @input="onInput"></color-picker>
      </v-container>
    </v-menu>

  </div>
</template>

<script>
import Color from '@/mixins/color'
import ColorPicker from '@radial-color-picker/vue-color-picker'

export default {
  name: "CalendarData",
  components: {ColorPicker},
  mixins: [Color],
  data() {
    return {
      eventName: '',
      eventDescription: '',
      eventDate: '',
      eventTime: '',
    }
  },
  methods: {
    getCalendarData() {
      return {
        name_template: this.eventName,
        description_template: this.eventDescription,
        date_template: this.eventDate,
        time_template: this.eventTime,
        color: this.hexColor
      }
    },
    updateCalendar() {
      this.$emit('updated', {data: this.getCalendarData()})
    }
  }
}
</script>

<style scoped>
@import '~@radial-color-picker/vue-color-picker/dist/vue-color-picker.min.css';
</style>